import React, { useState, useMemo, useContext, useEffect } from "react";
import { Button, Col, Container, Row, Card, CardBody } from "reactstrap";
import { useQuery, useQueryClient } from "react-query";
import { Modal, Skeleton, Spin } from "antd";
import HistoryContext from "../../../../common/HistoryContext";
import toast from "react-hot-toast";
import { deleteDeveloper, getAllDevelopers } from "../services/developerApi";
import CompleteCompanyDeveloper from "../../../company/component/completeCompany";
import '../utils/style.css';
import DeleteModalOTP from "../../../../common/delete/modalDeleteOtp.js";
import DetailBusiness from "../component/detailDeveloper";
import ValidateBusiness from "../component/validateBusiness.js";
import { getAllMerchent, getBusinessMarchandById } from "../../merchant/services/merchentApi.js";
import filter from "../../../../assets/images/cuida_filter-outline.png";
import trier from "../../../../assets/images/mdi_sort.png";
import defaultAvatar from "../../../../assets/images/image business défaut.png";
import vectorIcon from "../../../../assets/images/menu-alt-2.png";
import vector from "../../../../assets/images/Vector.png";
import empty from "../../../../assets/images/emptyBusiness.png";
import { useNavigate } from "react-router-dom";
import FiltrerBusinessModal from "../component/FiltrerBusinessModal .js";
import TrierBusinessModal from "../component/TrierBusinessModal.js";
import TableContainerMin from "../../../../common/TableContainerMin.js";
const BusinessManagement = ({ selectedMarchand,title,data}) => {
    const navigate = useNavigate();
  const history = useContext(HistoryContext);
     const [showDropdown, setShowDropdown] = useState(false); 
  const queryClient = useQueryClient();
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
  document.title = `Business | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
  const [modalState, setModalState] = useState({ type: null, data: null });
  const [isDeleting, setIsDeleting] = useState(false);
  const currentuser = JSON.parse(sessionStorage.getItem('authUser'));
  const merchandId = currentuser?.user?.id;
  const [sortOrder, setSortOrder] = useState("asc");
const { data: developers,isLoading, isError, error } = useQuery(
  ["developers", selectedMarchand],
  async () => {
    const data = selectedMarchand
      ? await getBusinessMarchandById(selectedMarchand)
      : await getAllDevelopers();

    return data.map((item) => ({
      ...item,
      id: item.id ?? item.businessId ?? item.developerId,
    }));
  }
);
  const {  } = useQuery("merchents", getAllMerchent);
  const tabs = ['Tous', 'Actives', 'En cours', 'Désactivés', 'Rejetés'];
  const [activeTab, setActiveTab] = useState('Tous');
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
 const [searchTerm, setSearchTerm] = useState("");
const [filterValues, setFilterValues] = useState(null);
 const handleApplyFilters = (filters) => {
  setFilterValues(filters);
};
const filteredDevelopers = useMemo(() => {
  if (!developers || developers.length === 0) return [];

  let result = [...developers];
if (filterValues) {
    if (filterValues.isActive!=="") {
      result = result.filter((t) => t.isActive === filterValues.isActive);
    } 
    if (filterValues.countrie) {
      result = result.filter((t) => t.country === filterValues.countrie);
    }

    if (filterValues.requestDate) {
        result = result.filter((t) => {
          const txDate = new Date(t.requestDate).toISOString().slice(0, 10);
          return txDate === filterValues.requestDate;
        });
      }
    if (filterValues.minAmount != null) {
      result = result.filter((t) => t.amount >= filterValues.minAmount);
    }
    if (filterValues.maxAmount != null) {
      result = result.filter((t) => t.amount <= filterValues.maxAmount);
    }
  }
  if (searchTerm) {
    const lowerSearch = searchTerm.toLowerCase();
    result = result.filter(dev =>
      dev.businessName?.toLowerCase().includes(lowerSearch) ||
      dev.merchantName?.toLowerCase().includes(lowerSearch) ||
      dev.country?.toLowerCase().includes(lowerSearch)
    );
  }
  if (sortOrder === "asc") {
            result.sort((a, b) => new Date(a.requestDate) - new Date(b.requestDate));
          } else {
            result.sort((a, b) => new Date(b.requestDate) - new Date(a.requestDate));
          }

  return result;
}, [developers,searchTerm,filterValues,sortOrder]);
  const openModal = (type, data = null) => {
    setModalState((prevState) => (prevState.type === type ? { type: null, data: null } : { type, data }));
  };

  const handleEdit = (developer) => {
    openModal("edit", developer);
  };

  const handleDetail = (developer) => {
    navigate(`/business-management/${developer.id}`);
  };
  const handleValidate = (developer) => {
    openModal("valid", developer);
  };

  const openDeleteConfirmModal = (developerId) => {
    const developerToDelete = developers.find(developer => developer.id === developerId);
    if (developerToDelete) {
      setModalState({
        type: "delete",
        data: { developerId, developerName: developerToDelete.businessName },
      });
    }
  };
  const closeDeleteConfirmModal = () => {
    setModalState({ type: null, data: null });
  };

  const handleDelete = async (developerId) => {
    setIsDeleting(true);
    try {
      await deleteDeveloper(developerId);
      queryClient.invalidateQueries("developers");
      toast.success("Le business a été supprimé avec succès");
    } catch (error) {
      toast.error(`😔 Erreur lors de la suppression du business : ${error?.message || error}`);
    } finally {
      setIsDeleting(false);
      closeDeleteConfirmModal();
    }
  };
   const countries = useMemo(() => {
    const allCountries = filteredDevelopers.map(t => t.country).filter(Boolean);
    return [...new Set(allCountries)];
  }, [filteredDevelopers]);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const columns = useMemo(() => [
{
  Header: "Nom Business",
  accessor: "businessName",
  filterable: false,
  Cell: ({ row }) => {
    const { businessName, logo } = row.original;
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <span>
        <img
          src={logo || defaultAvatar}
          alt=''
          style={{
            width: 29,
            height: 29,
            borderRadius: "50%",
            objectFit: "cover"
          }}
        />
        </span>
        <span>{businessName}</span>
        </div>
      );
    }
    },
        {
        Header: "Date création",
        accessor: "requestDate",
        Cell: ({ value }) =>
          value
      ? new Date(value).toLocaleString("fr-FR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })
      : "-",
    filterable: false,
    },

{
  Header: "Commission",
  accessor: "totalCommissionXof",
  filterable: false,
  Cell: ({ value, row }) => {
    const amount = value ?? 0;
    const currency = row.original.currency ?? "XOF";

    return (
      <span style={{ fontWeight: 600 }}>
        {amount.toLocaleString("fr-FR")} {currency}
      </span>
    );
  },
},
    { Header: "Pays", accessor: "country", filterable: false },
   {
    Header: "Environnement",
    accessor: "environment",
    Cell: ({ row }) => {
      const value = row.original.environmentMod ?? row.original.environment;

      let label = "Non défini";
      let style = {
        backgroundColor: "#FFEFD5",
        color: "#000",
        padding: "1px 6px",
        borderRadius: "100px",
        fontWeight: 400,
        fontSize: "13px",
        fontStyle: 'Medium'
      };
      if (value=== 'SANDBOX') {
        label = "SANDBOX";
        style.backgroundColor = "#FFF3D6";
        style.color = "#E8AC1E";          
      } else if (value=== 'LIVE') {
        label = "Production";
        style.backgroundColor = "#EBFFEA";
        style.color = "#349C32";  
      }
      
      return (
      <span style={style}>
        <span></span> {label}
      </span>
    );
    },
    filterable: false,
    },
    {
    Header: "Montant",
    accessor: "availableAmount",
    Cell: ({ row }) => {
      const { environmentMod, sandboxBalance, availableBalance } = row.original;
      const availableAmount =
        environmentMod === "SANDBOX"
          ? sandboxBalance
          : environmentMod === "LIVE"
          ? availableBalance
          : 0;
      return (
        <span
          style={{
            fontWeight: 600,
            fontSize: "13px",
            color: "#070707",
            fontFamily: "Poppins",
          }}
        >
         {availableAmount?.toLocaleString("fr-FR")} XOF
        </span>
      );
    },
    filterable: false,
},
{
    Header: "Identification",
    accessor: "isActive",
    Cell: ({ value }) => {
      let label = "Non défini";
      let style = {
        backgroundColor: "#FFEFD5",
        color: "#000",
        padding: "1px 6px",
        borderRadius: "100px",
        fontWeight: 400,
        fontSize: "13px",
        fontStyle: 'Medium'
      };
        let icon = "❓";
      if (value=== true) {
        label = "Activé";
         icon = "✓";
        style.backgroundColor = "#EBFFEA";
        style.color = "#349C32";          
      } else if (value=== false) {
        label = "Désactivé";
         icon = "🚫";
         style.backgroundColor = "#FFF0F0";
        style.color = "#D41C1C";  
      }
      return (
      <span style={style}>
        <span>{icon}</span> {label}
      </span>
    );
    },
    filterable: false,
    },  
    {
     Header: () => (
    <div style={{ textAlign: "right", width: "100%" }}>
      Action
    </div>
  ),
  accessor: "action",
      Cell: ({ row }) => {
        return (
          
           <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: "24px",
                height: "24px",
                backgroundColor: "#FFFFFF",
                borderRadius: "50%",
                cursor: "pointer",
                border: "1px solid #00000014",
              }}
            onClick={(e) => {
          e.stopPropagation();
          setSelectedBusiness(row.original); 
          const rect = e.currentTarget.getBoundingClientRect();
              setModalPosition({
              top: rect.bottom + window.scrollY,
              left: rect.left + window.scrollX -250,
            });
          setIsModalOpen(true); 
        }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="6" cy="12" r="2" fill="#21272A" />
                <circle cx="12" cy="12" r="2" fill="#21272A" />
                <circle cx="18" cy="12" r="2" fill="#21272A" />
              </svg>
            </div>
          </div>
        );
      },
      filterable: false,
    },
  ], [handleEdit, openDeleteConfirmModal, handleDetail, handleValidate]);


 
  const HeaderTable = () => (
    <div className="d-flex flex-column align-items-start gap-3 w-100">
      <div className=' mb-2'style={{color:"#444444",fontFamily:"Poppins",fontSize:"15px",fontWeight:'500'}}>
        {title}
        <span className="lenght">
      {isLoading ? (
        <Spin size="small" />
      ) : !developers?.length ? (
        "0"
      ) : (
        developers.length
      )}
    </span>
        </div>

</div>
      );
  return (
    <React.Fragment>
      <Card className="h-100 w-100" style={{ borderRadius: "10px",background:"#FFFFFF",border:'none' }}>
      <div className="page-content">
        <Container fluid>
          <HeaderTable />
              <div className="header-actions w-100 mb-2">
   
            <div className="col-6">
              <input
                type="text"
                placeholder="Rechercher un marchand..."
                className="form-control search"
                 value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
              <>
            <Button className="filtrer" onClick={() => openModal("transaction-filtrer")} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <img src={filter} alt="Filtrer" style={{ width: "24px", height: "24px" }} />
            Filtrer
            </Button>
            <Button onClick={() => openModal("business-trier")} className="filtrer" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <img src={trier} alt="Filtrer" style={{ width: "24px", height: "24px" }} />
            Trier
          </Button>
          </>
        </div>
          <Row>
            <Col>
             <Card className="h-100 w-100"style={{ borderRadius: "10px",background:"#FFFFFF",border:'none' }} >
                <CardBody className="p-0 ">
                  {isLoading ? (
                <div style={{ padding: "20px" }}>
                  <Skeleton active paragraph={{ rows: 8 }} />
                </div>
              ) : (
                <TableContainerMin
                  columns={columns}
                  data={filteredDevelopers}
                  isGlobalFilter={false}
                  customPageSize={10}
                  className="custom-header-css"
                  divClass="table-responsive"
                  tableClass="table w-100 mb-0 no-column-borders"
                  theadClass="custom-thead"
                  SearchPlaceholder="Recherche..."
                  HeaderTable={HeaderTable}
                />
              )}
                  {isLoading && !isError && (
                    <div className="text-center">
                     <Skeleton />
                    </div>
                  )}
                  {filteredDevelopers && filteredDevelopers.length === 0 && !isLoading && (
                  <div style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "40px 0"
                    }}
                  >
                  <img
                  src={empty} 
                  alt="Liste vide"
                  style={{ width: "150px"}}
                /></div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
           <Modal
            open={isModalOpen}
            onCancel={() => setIsModalOpen(false)}
            footer={null}
            width={211}
            style={{
              background:"#FFFFFF",
              position: "absolute",
              top: modalPosition.top,
              left: modalPosition.left,
              borderRadius: 10,
              border: "1px solid #DFDFDF",
              padding: 0,
              boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            }}
            bodyStyle={{ padding: "8px 1px" }}
            mask={false}
            closable={false}
            >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "12px",
              }}
            >
              <a
              onClick={() => {
                handleDetail(selectedBusiness)
                setIsModalOpen(false);
              }}
              style={{ display: "flex", alignItems: "start", gap: "8px", cursor: "pointer" }}
            >
            <img src={vectorIcon} alt="Voir détails" style={{ width: 20, height: 20 }} />

              <span class="actions">Détails</span>
            </a>
            </div>
          </Modal>
          {modalState.type === "detail" && (
            <DetailBusiness
              modal={modalState.type === "detail"}
              setModal={setModalState}
              toggle={() => openModal("detail", modalState.data)}
              selectedDeveloper={modalState.data}
              currentuser={currentuser}
            />
          )}
          {modalState.type === "complete" && (
            <CompleteCompanyDeveloper
              modal={modalState.type === "complete"}
              setModal={setModalState}
              toggle={() => openModal("complete", modalState.data)}
              selectedCompany={modalState.data}
              currentuser={currentuser}
            />
          )}
          {modalState.type === "delete" && (
            <DeleteModalOTP
              isOpen={true}
              title={`du business ${modalState.data.developerName}`}
              loading={isDeleting}
              onCancel={closeDeleteConfirmModal}
              onConfirm={() => handleDelete(modalState.data.developerId)}
            />
          )}
          {modalState.type === "valid" && (
            <ValidateBusiness
              modal={modalState.type === "valid"}
              setModal={setModalState}
              toggle={() => openModal("valid", modalState.data)}
              selectedDeveloper={modalState.data}
              mode="validate"
            />
          )}
          {modalState.type === "disable" && (
            <ValidateBusiness
              modal={modalState.type === "disable"}
              setModal={setModalState}
              toggle={() => openModal("disable", modalState.data)}
              selectedDeveloper={modalState.data}
              mode="disable"
            />
          )}
            {modalState.type === "transaction-filtrer" && (
              <FiltrerBusinessModal
                isOpen={modalState.type === "transaction-filtrer"}
                toggle={() => openModal("transaction-filtrer", modalState.data)}
                onApply={handleApplyFilters}
                 countries={countries}
              />
            )}
               {modalState.type === "business-trier" && (
            <TrierBusinessModal
              isOpen={modalState.type === "business-trier"}
              toggle={() => openModal("business-trier", modalState.data)}
              onApplySort={(order) => setSortOrder(order)}
            />
          )}
        </Container>
      </div>
      </Card>
    </React.Fragment>
  );
};

export default BusinessManagement;
